import React from 'react';

// Digitally-altered disclosure bar overlaid on an image container. Uses inline styles because doc pages
// render into a shadow DOM where app stylesheet classes do not apply. Links to the /go short link, never
// the broker's raw original URL. `compact` renders just the "Digitally Altered" marker (no link) for small
// thumbnails, matching the per-thumbnail marker on the Quokka image gallery.
const CAPTION_STYLE: React.CSSProperties = {
  position: 'absolute',
  right: 0,
  bottom: 0,
  left: 0,
  padding: '6px 10px',
  backgroundColor: 'rgba(51, 51, 51, 0.6)',
  color: '#fff',
  fontSize: '12px',
  lineHeight: 1.3,
  letterSpacing: '0.01em',
  textAlign: 'center',
  wordBreak: 'break-word',
};

const COMPACT_STYLE: React.CSSProperties = {
  ...CAPTION_STYLE,
  padding: '2px 6px',
  fontSize: '10px',
};

const URL_STYLE: React.CSSProperties = {
  color: '#fff',
  textDecoration: 'underline',
};

interface Props {
  originalUrlShortLink?: string | null,
  asLink?: boolean,
  compact?: boolean,
}

export default function DisclosureCaption({ originalUrlShortLink, asLink, compact }: Props) {
  if (compact) {
    return (
      <div style={COMPACT_STYLE}>
        Digitally Altered
        {asLink && originalUrlShortLink && (
          <>
            {' · '}
            <a href={originalUrlShortLink} rel="noopener noreferrer" style={URL_STYLE} target="_blank">
              view original
            </a>
          </>
        )}
      </div>
    );
  }

  const label = originalUrlShortLink?.replace(/^https?:\/\//, '');

  return (
    <div style={CAPTION_STYLE}>
      Digitally Altered · view original at{' '}
      {asLink && originalUrlShortLink ? (
        <a href={originalUrlShortLink} rel="noopener noreferrer" style={URL_STYLE} target="_blank">
          {label}
        </a>
      ) : (
        <span style={URL_STYLE}>{label}</span>
      )}
    </div>
  );
}
